import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

const HighlightedSearchesServices = {
  deleteSearch: async (_id: string): Promise<any> => {
    return await request({
      method: "delete",
      baseURL: `${process.env.REACT_APP_API_URL}/highlightedSearches/${_id}`,
    });
  },

  editSearch: async (_id: string, search: string): Promise<any> => {
    return await request({
      method: "put",
      baseURL: `${process.env.REACT_APP_API_URL}/highlightedSearches/${_id}`,
      data: { search },
    });
  },
  getHighlightedSearchs: async (): Promise<any> => {
    return await request({
      baseURL: RTABAK_URLS.API.GetHighlightedSearches,
      method: "GET",
      headers: {
        Accept: "aplication/json",
      },
    });
  },
};

export { HighlightedSearchesServices };
